"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const XYPosition_1 = require("./XYPosition");
exports.LabelSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('label'),
    pos: XYPosition_1.XYPositionSchema,
    orientation: zod_1.z.enum(['L', 'D', 'R', 'U']),
    shape: zod_1.z.enum(['input', 'output', 'bidirectional', 'neutral']),
    value: zod_1.z.string(),
    net: zod_1.z.coerce.string().optional(),
    filled: zod_1.z.coerce.boolean().optional(),
});
//# sourceMappingURL=Label.js.map